export default __webpack_public_path__ + "static/media/mobile.38eae616.png";